/* ==========================================================================
   PERSONNALISATION MJF - Moteur du formulaire d'options
   --------------------------------------------------------------------------
   Fichier : assets/mjf-perso.js
   A charger depuis layout/theme.liquid, avant </body> :
     <script src="{{ 'mjf-perso.js' | asset_url }}" defer></script>

   Role :
   1. Construit le formulaire depuis la config JSON du snippet
      mjf-perso-config.liquid (types, conditions, prix live).
   2. Evalue les conditions a chaque saisie ; un champ masque est vide.
   3. A l'ajout au panier : si la personnalisation est active, intercepte
      l'envoi du theme et le remplace par UN SEUL /cart/add.js contenant
      le produit + toutes les lignes d'option, liees par la convention
      _box_ligne / _box_parent. Le panier groupe, verrouille et cascade
      donc exactement comme pour le box builder, sans aucun code en plus.
      Si la personnalisation est inactive, le theme fait son ajout
      normalement : zero interference.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__mjfPerso) return;
  window.__mjfPerso = true;

  /* ---------------- utilitaires ---------------- */

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html !== undefined) n.innerHTML = html;
    return n;
  }

  /* =========================================================
     Un moteur par bloc [data-mjf-perso] present dans la page
     ========================================================= */

  function Perso(root, champs) {
    this.root = root;

    /* Les champs sont attribues par init() : chaque bloc champ
       appartient au bloc maitre place au-dessus de lui. */
    if (!champs || !champs.length) return;
    this.config = { champs: champs };

    this.champPrincipal = root.getAttribute('data-champ-principal') || 'broderie';
    this.titreCadeau = root.getAttribute('data-titre-cadeau') || 'Options cadeau';
    this.soustitreCadeau = root.getAttribute('data-soustitre-cadeau') || '';
    this.champConditionnel = (root.getAttribute('data-si-rempli') || '').trim();

    this.corps = root.querySelector('[data-mjf-perso-corps]');
    this.prixTete = root.querySelector('[data-mjf-perso-prix]');
    this.tete = root.querySelector('[data-mjf-perso-tete]');
    this.soustitre = root.querySelector('[data-mjf-perso-soustitre]');
    this.zoneErreur = root.querySelector('[data-mjf-perso-erreur]');

    /* etat : id de champ -> { valeur, choix } */
    this.etat = {};
    this.noeuds = {};

    this.construire();
    this.brancher();
    this.evaluer();
  }

  /* ---------------- construction du formulaire ---------------- */

  Perso.prototype.construire = function () {
    var self = this;
    var groupes = {};

    this.config.champs.forEach(function (champ) {
      var bloc = el('div', 'mjf-perso__champ');
      bloc.setAttribute('data-champ', champ.id);

      if (champ.type === 'interrupteur') {
        self.construireInterrupteur(bloc, champ);
      } else if (champ.type === 'texte' || champ.type === 'zonetexte') {
        self.construireTexte(bloc, champ);
      } else if (champ.type === 'pastilles') {
        self.construirePastilles(bloc, champ);
      }

      self.noeuds[champ.id] = bloc;

      if (champ.hors_accordeon) {
        /* Champ rendu sur la fiche, a l'endroit ou son bloc est pose :
           il reste pilote par ce moteur (conditions, validation,
           lignes panier) mais vit hors du corps de l'accordeon. */
        var hote = document.querySelector(
          '[data-mjf-perso-hote="' + champ.id.replace(/"/g, '') + '"]'
        );
        if (hote) {
          bloc.classList.add('mjf-perso__champ--hote');
          hote.appendChild(bloc);
        } else {
          self.corps.appendChild(bloc);
        }
      } else if (champ.groupe) {
        if (!groupes[champ.groupe]) {
          groupes[champ.groupe] = self.construireGroupe(champ.groupe);
        }
        groupes[champ.groupe].contenu.appendChild(bloc);
      } else {
        self.corps.appendChild(bloc);
      }
    });

    Object.keys(groupes).forEach(function (nom) {
      self.corps.appendChild(groupes[nom].bloc);
    });

    var total = el('div', 'mjf-perso__total is-cache');
    total.innerHTML = '<span>Total des options</span><span data-mjf-perso-montant></span>';
    this.corps.appendChild(total);
    this.zoneTotal = total;
    this.zoneMontant = total.querySelector('[data-mjf-perso-montant]');
  };

  Perso.prototype.construireGroupe = function (nom) {
    var bloc = el('div', 'mjf-perso__groupe');
    bloc.setAttribute('data-groupe', nom);

    var tete = el('button', 'mjf-perso__groupe-tete');
    tete.type = 'button';
    tete.innerHTML =
      '<span class="mjf-perso__groupe-icone" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="3" y="8" width="18" height="4" rx="1"></rect>' +
      '<path d="M12 8v13"></path>' +
      '<path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>' +
      '<path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"></path>' +
      '</svg></span>' +
      '<span class="mjf-perso__groupe-textes">' +
      '<span class="mjf-perso__groupe-titre"></span>' +
      '<span class="mjf-perso__groupe-soustitre is-cache"></span>' +
      '</span>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="margin-left:auto"><path d="M6 9l6 6 6-6"></path></svg>';

    tete.querySelector('.mjf-perso__groupe-titre').textContent = this.titreCadeau;
    if (this.soustitreCadeau) {
      var sousNoeud = tete.querySelector('.mjf-perso__groupe-soustitre');
      sousNoeud.textContent = this.soustitreCadeau;
      sousNoeud.classList.remove('is-cache');
    }

    var contenu = el('div', 'is-cache');

    tete.addEventListener('click', function () {
      var ouvert = bloc.classList.toggle('is-open');
      contenu.classList.toggle('is-cache', !ouvert);
    });

    bloc.appendChild(tete);
    bloc.appendChild(contenu);
    return { bloc: bloc, contenu: contenu };
  };

  Perso.prototype.construireInterrupteur = function (bloc, champ) {
    var self = this;

    var image = '';
    if (champ.image) {
      var cote = champ.taille_image || 56;
      image =
        '<span class="mjf-perso__switch-img" style="width:' + cote + 'px;height:' + cote + 'px">' +
        '<img src="' + champ.image + '" alt="" loading="lazy" width="' + cote + '" height="' + cote + '">' +
        '</span>';
    }

    /* L'infobulle vit HORS du label : un bouton dans un label capte
       les clics et empeche la case ou la bascule de reagir. */
    var boutonInfo = null;
    var texteInfo = null;
    if (champ.infobulle) {
      boutonInfo = el('button', 'mjf-perso__info', '?');
      boutonInfo.type = 'button';
      boutonInfo.setAttribute('aria-label', 'Informations');
      texteInfo = el('p', 'mjf-perso__info-texte is-cache');
      texteInfo.textContent = champ.infobulle;
      boutonInfo.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        texteInfo.classList.toggle('is-cache');
      });
    }

    var label = el('label', 'mjf-perso__switch');

    if (champ.style_affichage === 'bascule') {
      var entete = el('div', 'mjf-perso__bascule-entete');
      entete.innerHTML = image + '<span class="mjf-perso__switch-titre">' + champ.label + '</span>';
      if (boutonInfo) entete.appendChild(boutonInfo);
      bloc.appendChild(entete);
      if (champ.sous_label) {
        bloc.appendChild(el('p', 'mjf-perso__aide', champ.sous_label));
      }

      label.className = 'mjf-perso__switch mjf-perso__switch--bascule';
      var basculePrix =
        champ.prix > 0
          ? ' <span style="color:rgb(0 0 0 / 0.5);font-size:11px;font-weight:400">(+' + euros(champ.prix) + ')</span>'
          : '';
      label.innerHTML =
        '<input type="checkbox"><span class="mjf-perso__piste" aria-hidden="true"></span>' +
        '<span class="mjf-perso__bascule-oui">Oui' + basculePrix + '</span>';
      bloc.appendChild(label);
    } else {
      var texte = '<span class="mjf-perso__switch-titre">' + champ.label;
      if (champ.sous_label) {
        texte += '<span class="mjf-perso__switch-sous">' + champ.sous_label + '</span>';
      }
      texte += '</span>';
      var prix = '';
      if (champ.prix > 0) {
        prix =
          '<span class="mjf-perso__switch-prix" style="font-weight:400;color:rgb(0 0 0 / 0.5);font-size:11px;margin-left:auto;padding-left:8px;white-space:nowrap">(+' +
          euros(champ.prix) +
          ')</span>';
      }
      label.innerHTML = '<input type="checkbox">' + image + texte + prix;
      label.style.flex = '1';

      var ligne = el('div', 'mjf-perso__ligne-case');
      ligne.appendChild(label);
      if (boutonInfo) ligne.appendChild(boutonInfo);
      bloc.appendChild(ligne);
    }

    if (texteInfo) bloc.appendChild(texteInfo);

    var input = label.querySelector('input');
    if (!champ.dispo) {
      input.disabled = true;
      label.style.opacity = '0.45';
    }

    input.addEventListener('change', function () {
      self.etat[champ.id] = input.checked ? { valeur: 'oui' } : null;
      self.evaluer();
    });
  };

  Perso.prototype.construireTexte = function (bloc, champ) {
    var self = this;
    bloc.innerHTML =
      '<span class="mjf-perso__label">' + champ.label + (champ.requis ? ' *' : '') + '</span>';

    var input;
    if (champ.type === 'zonetexte') {
      input = el('textarea', 'mjf-perso__textarea');
    } else {
      input = el('input', 'mjf-perso__input');
      input.type = 'text';
      input.setAttribute('autocomplete', 'off');
      input.style.height = '42px';
      input.style.minHeight = '0';
      input.style.resize = 'none';
    }
    if (champ.placeholder) input.placeholder = champ.placeholder;
    if (champ.max) input.maxLength = champ.max;

    bloc.appendChild(input);

    var sous = el('div', 'mjf-perso__sousinput');
    var surcout = el('span', 'mjf-perso__surcout is-cache');
    var compteur = el('span', 'mjf-perso__compteur', '0 / ' + (champ.max || ''));
    if (champ.seuil > 0) sous.appendChild(surcout);
    if (champ.max) sous.appendChild(compteur);
    bloc.appendChild(sous);

    if (champ.seuil > 0) {
      if (!this.__champsAvecSeuil) this.__champsAvecSeuil = [];
      this.__champsAvecSeuil.push({ champ: champ, noeud: surcout });
    }

    if (champ.aide) bloc.appendChild(el('p', 'mjf-perso__aide', champ.aide));

    var caseExemption = null;
    if (champ.type === 'zonetexte' && champ.case) {
      var ligneCase = el('label', 'mjf-perso__case-exemption');
      ligneCase.innerHTML = '<input type="checkbox"><span>' + champ.case + '</span>';
      caseExemption = ligneCase.querySelector('input');
      caseExemption.addEventListener('change', function () {
        if (caseExemption.checked) {
          input.value = '';
          input.disabled = true;
          if (champ.max) compteur.textContent = '0 / ' + champ.max;
          self.etat[champ.id] = { valeur: champ.case };
        } else {
          input.disabled = false;
          self.etat[champ.id] = null;
        }
        bloc.classList.remove('is-missing');
        self.rafraichirTotal();
      });
      bloc.appendChild(ligneCase);
    }

    input.addEventListener('input', function () {
      var v = input.value.trim();
      self.etat[champ.id] = v ? { valeur: v } : null;
      if (champ.max) compteur.textContent = input.value.length + ' / ' + champ.max;
      bloc.classList.remove('is-missing');
      self.rafraichirTotal();
    });

    bloc.__input = input;
    bloc.__caseExemption = caseExemption;
  };

  Perso.prototype.construirePastilles = function (bloc, champ) {
    var self = this;
    bloc.innerHTML =
      '<span class="mjf-perso__label">' + champ.label + (champ.requis ? ' *' : '') + '</span>';

    /* Compteur de selection dans le libelle, pour les champs a
       selection multiple : sur un long carrousel, la note sous la
       rangee sort de l'ecran, le libelle reste toujours visible. */
    var compteurSel = null;
    if (champ.multi) {
      compteurSel = el('span', 'mjf-perso__compteur-sel');
      bloc.querySelector('.mjf-perso__label').appendChild(compteurSel);
    }

    var rangee = el('div', 'mjf-perso__opts');
    if (champ.style === 'carrousel') {
      rangee.className = 'mjf-perso__opts mjf-perso__opts--carrousel';
    }
    if (champ.style === 'images') {
      rangee.className = 'mjf-perso__opts mjf-perso__opts--grille';
      rangee.style.setProperty('--mjf-perso-cols', champ.colonnes || 2);
      rangee.style.setProperty('--mjf-perso-cols-m', champ.colonnes_mobile || 2);
    }
    var note = el('span', 'mjf-perso__opt-note');

    (champ.choix || []).forEach(function (choix) {
      var b = el('button');
      b.type = 'button';

      if (champ.style === 'vignettes') {
        b.className = 'mjf-perso__opt mjf-perso__opt--vignette';
        b.setAttribute('aria-label', choix.libelle);
        b.title = choix.libelle + (choix.prix > 0 ? ' (+' + euros(choix.prix) + ')' : '');
        var vignette = '';
        if (choix.badge) vignette += '<span class="mjf-perso__badge">' + choix.badge + '</span>';
        if (choix.image) vignette += '<img src="' + choix.image + '" alt="" loading="lazy" width="54" height="54">';
        b.innerHTML = vignette;
      } else if (champ.style === 'carrousel') {
        b.className = 'mjf-perso__opt mjf-perso__opt--carte';
        var carteC = '<span class="mjf-perso__coche" aria-hidden="true">\u2713</span>';
        if (choix.badge) carteC += '<span class="mjf-perso__badge">' + choix.badge + '</span>';
        if (choix.image) carteC += '<img src="' + choix.image + '" alt="" loading="lazy">';
        carteC += '<span class="mjf-perso__carte-nom">' + choix.libelle + '</span>';
        if (choix.prix > 0 && choix.montrer_prix !== false) {
          carteC += '<span class="mjf-perso__opt-sousprix">(+' + euros(choix.prix) + ')</span>';
        }
        b.innerHTML = carteC;
      } else if (champ.style === 'images') {
        b.className = 'mjf-perso__opt mjf-perso__opt--img';
        var carte = '<span class="mjf-perso__radio" aria-hidden="true"></span>';
        carte += '<span class="mjf-perso__vignette">';
        if (choix.badge) {
          carte += '<span class="mjf-perso__badge">' + choix.badge + '</span>';
        }
        if (choix.image) {
          carte += '<img src="' + choix.image + '" alt="" loading="lazy" width="46" height="46">';
        }
        carte += '</span>';
        carte += '<span class="mjf-perso__opt-textes">';
        carte += '<span class="mjf-perso__opt-nom">' + choix.libelle + '</span>';
        if (choix.prix > 0 && choix.montrer_prix !== false) {
          carte +=
            '<span class="mjf-perso__opt-sousprix">(+' + euros(choix.prix) + ')</span>';
        }
        carte += '</span>';
        b.innerHTML = carte;
      } else if (champ.style === 'couleurs' && choix.hex) {
        b.className = 'mjf-perso__opt mjf-perso__opt--rond';
        b.style.background = choix.hex;
        b.setAttribute('aria-label', choix.libelle);
        b.title = choix.libelle + (choix.prix > 0 ? ' (+' + euros(choix.prix) + ')' : '');
      } else {
        b.className = 'mjf-perso__opt';
        b.innerHTML =
          choix.libelle +
          (choix.prix > 0
            ? '<span class="mjf-perso__opt-prix" style="color:rgb(0 0 0 / 0.5);font-size:11px;font-weight:400;margin-left:4px">(+' + euros(choix.prix) + ')</span>'
            : '');
      }

      if (!choix.dispo) b.disabled = true;

      b.addEventListener('click', function () {
        if (champ.multi) {
          var actuel = self.etat[champ.id];
          var liste = actuel && actuel.choixMultiples ? actuel.choixMultiples : [];
          /* Identification par l'objet lui-meme, jamais par le libelle :
             plusieurs cartes peuvent porter le meme nom (« Francais »,
             « Porte Coran en Plexi »...), et une comparaison de texte
             melangerait leurs selections. */
          var position = liste.indexOf(choix);
          if (position > -1) {
            liste.splice(position, 1);
            b.classList.remove('is-on');
          } else {
            liste.push(choix);
            b.classList.add('is-on');
          }
          if (liste.length) {
            var noms = [];
            var sousTotal = 0;
            for (var m = 0; m < liste.length; m++) {
              noms.push(liste[m].libelle);
              sousTotal += liste[m].prix;
            }
            self.etat[champ.id] = { valeur: noms.join(', '), choixMultiples: liste };
            note.textContent = liste.length + ' s\u00e9lectionn\u00e9' + (liste.length > 1 ? 's' : '') + (sousTotal > 0 ? ' \u00b7 +' + euros(sousTotal) : '');
          } else {
            self.etat[champ.id] = null;
            note.textContent = '';
          }
          if (compteurSel) {
            compteurSel.textContent = liste.length ? ' \u00b7 ' + liste.length : '';
          }
          bloc.classList.remove('is-missing');
          self.evaluer();
          return;
        }

        var actuel = self.etat[champ.id];
        var deja = actuel && actuel.valeur === choix.libelle;

        rangee.querySelectorAll('.is-on').forEach(function (n) {
          n.classList.remove('is-on');
        });

        /* Le declencheur reste toujours deselectionnable : c'est la
           porte de sortie de la personnalisation, meme marque requis. */
        if (deja && (!champ.requis || champ.id === self.champPrincipal)) {
          self.etat[champ.id] = null;
          note.textContent = '';
        } else {
          b.classList.add('is-on');
          self.etat[champ.id] = { valeur: choix.libelle, choix: choix };
          note.textContent =
            champ.style === 'couleurs' || champ.style === 'vignettes'
              ? choix.libelle + (choix.prix > 0 ? ' (+' + euros(choix.prix) + ')' : '')
              : '';
        }

        bloc.classList.remove('is-missing');
        self.evaluer();
      });

      rangee.appendChild(b);
    });

    if (champ.style === 'couleurs' || champ.style === 'vignettes' || champ.multi) {
      rangee.appendChild(note);
    }
    bloc.appendChild(rangee);
  };

  /* ---------------- conditions et affichage ---------------- */

  Perso.prototype.champVisible = function (champ) {
    if (!champ.si) return true;

    var cible = this.etat[champ.si.champ];
    var cibleConfig = null;
    for (var i = 0; i < this.config.champs.length; i++) {
      if (this.config.champs[i].id === champ.si.champ) cibleConfig = this.config.champs[i];
    }

    /* la cible doit elle-meme etre visible */
    if (cibleConfig && !this.champVisible(cibleConfig)) return false;

    if (champ.si.valeur === 'oui') return !!(cible && cible.valeur === 'oui');
    if (champ.si.valeur === '*') return !!(cible && cible.valeur);
    return !!(cible && cible.valeur === champ.si.valeur);
  };

  Perso.prototype.evaluer = function () {
    var self = this;
    var groupesVisibles = {};

    this.config.champs.forEach(function (champ) {
      var bloc = self.noeuds[champ.id];
      var visible = self.champVisible(champ);

      bloc.classList.toggle('is-cache', !visible);

      if (!visible && self.etat[champ.id]) {
        /* un champ masque perd sa valeur : jamais facture en douce */
        self.etat[champ.id] = null;
        var input = bloc.__input;
        if (input) {
          input.value = '';
          input.disabled = false;
        }
        if (bloc.__caseExemption) bloc.__caseExemption.checked = false;
        bloc.querySelectorAll('.is-on').forEach(function (n) {
          n.classList.remove('is-on');
        });
        var coche = bloc.querySelector('input[type="checkbox"]');
        if (coche) coche.checked = false;
      }

      if (visible && champ.groupe) groupesVisibles[champ.groupe] = true;
    });

    this.corps.querySelectorAll('[data-groupe]').forEach(function (g) {
      g.classList.toggle('is-cache', !groupesVisibles[g.getAttribute('data-groupe')]);
    });

    this.rafraichirTotal();
    appliquerVisibiliteMaitres();
  };

  /* ---------------- lignes a facturer ---------------- */

  Perso.prototype.lignes = function () {
    var self = this;
    var out = [];
    var actif = this.actif();

    this.config.champs.forEach(function (champ) {
      /* Personnalisation fermee : seuls les champs de la fiche comptent. */
      if (!actif && !champ.hors_accordeon) return;
      if (!self.champVisible(champ)) return;
      var etat = self.etat[champ.id];
      if (!etat || !etat.valeur) return;

      if (champ.type === 'interrupteur' && champ.facture_toujours && champ.variante) {
        out.push({ variante: champ.variante, prix: champ.prix, titre: champ.label });
        return;
      }

      if (champ.type === 'pastilles' && etat.choixMultiples) {
        etat.choixMultiples.forEach(function (c) {
          if (c.prix > 0) {
            out.push({ variante: c.variante, prix: c.prix, titre: c.libelle });
          }
        });
        return;
      }

      if (champ.type === 'pastilles' && etat.choix && etat.choix.prix > 0) {
        out.push({ variante: etat.choix.variante, prix: etat.choix.prix, titre: etat.choix.libelle });
        return;
      }

      if (champ.type === 'texte' && champ.variante && champ.prix > 0) {
        out.push({ variante: champ.variante, prix: champ.prix, titre: champ.label });
      }

      if (champ.type === 'texte' || champ.type === 'zonetexte') {
        var dep = self.infoDepassement(champ);
        if (dep) {
          out.push({ variante: dep.variante, prix: dep.prix, titre: 'D\u00e9passement caract\u00e8res' });
        }
      }
    });

    return out;
  };

  /* Supplement de depassement pour un champ texte dont la valeur
     depasse le seuil de caracteres inclus. Le bareme suit l'option
     selectionnee du Choix designe, sinon le produit fixe du champ. */
  Perso.prototype.infoDepassement = function (champ) {
    if (!champ.seuil || champ.seuil <= 0) return null;
    var etat = this.etat[champ.id];
    if (!etat || !etat.valeur) return null;
    if (etat.valeur.length <= champ.seuil) return null;

    var d = null;
    if (champ.bareme) {
      var cible = this.etat[champ.bareme];
      if (cible && cible.choix && cible.choix.depassement) d = cible.choix.depassement;
    }
    if (!d && champ.depassement) d = champ.depassement;
    if (!d || !d.variante || !d.dispo) return null;
    return d;
  };

  /* Un moteur participe a l'ajout si sa personnalisation est active,
     ou s'il porte des champs hors accordeon (visibles sur la fiche) :
     ceux-la doivent etre valides et envoyes meme accordeon ferme. */
  Perso.prototype.participe = function () {
    /* Un bloc masque par sa condition d'affichage n'envoie rien. */
    if (this.root.style.display === 'none') return false;
    if (this.actif()) return true;
    for (var i = 0; i < this.config.champs.length; i++) {
      var c = this.config.champs[i];
      if (!c.hors_accordeon) continue;
      if (!this.champVisible(c)) continue;
      if (c.requis) return true;
      var e = this.etat[c.id];
      if (e && e.valeur) return true;
    }
    return false;
  };

  /* Les champs a valider : ceux de la personnalisation quand elle est
     active, plus les champs hors accordeon dans tous les cas. */
  Perso.prototype.champsAValider = function () {
    var self = this;
    var actif = this.actif();
    return this.config.champs.filter(function (c) {
      if (!c.requis) return false;
      if (!self.champVisible(c)) return false;
      return actif || c.hors_accordeon;
    });
  };

  Perso.prototype.actif = function () {
    /* Le declencheur peut etre un interrupteur (valeur « oui ») ou un
       Choix (n'importe quelle option selectionnee, ex. : le type de
       personnalisation marquage / broderie).

       Declencheur laisse vide, ou pointant un champ absent de ce
       produit : n'importe quel champ rempli active le bloc. C'est le
       mode qui convient aux accordeons sans entree unique, comme un
       cross-sell dont le contenu change d'un produit a l'autre. */
    var existe = false;
    for (var i = 0; i < this.config.champs.length; i++) {
      if (this.config.champs[i].id === this.champPrincipal) existe = true;
    }

    if (this.champPrincipal && existe) {
      var e = this.etat[this.champPrincipal];
      return !!(e && e.valeur);
    }

    for (var k = 0; k < this.config.champs.length; k++) {
      var etat = this.etat[this.config.champs[k].id];
      if (etat && etat.valeur) return true;
    }
    return false;
  };

  Perso.prototype.rafraichirTotal = function () {
    var lignes = this.lignes();
    var total = 0;
    lignes.forEach(function (l) {
      total += l.prix;
    });

    if (this.zoneTotal) {
      /* Croquis A : le chiffre vit dans l'en-tete. La ligne Total ne
         revient que lorsqu'au moins deux supplements s'additionnent,
         sinon elle repeterait le meme montant deux fois. */
      var afficherTotal = lignes.length >= 2 && total > 0;
      this.zoneTotal.classList.toggle('is-cache', !afficherTotal);
      if (this.zoneMontant) this.zoneMontant.textContent = '+' + euros(total);
    }
    if (this.__champsAvecSeuil) {
      for (var cs = 0; cs < this.__champsAvecSeuil.length; cs++) {
        var suivi = this.__champsAvecSeuil[cs];
        var dep = this.infoDepassement(suivi.champ);
        if (dep) {
          suivi.noeud.textContent =
            '+ de ' + suivi.champ.seuil + ' caract\u00e8res : (+' + euros(dep.prix) + ')';
          suivi.noeud.classList.remove('is-cache');
        } else {
          suivi.noeud.classList.add('is-cache');
        }
      }
    }

    if (this.prixTete) {
      var prefixe = (this.root.getAttribute('data-prefixe-prix') || '').trim();
      if (prefixe) prefixe += ' ';
      if (this.actif() && total > 0) {
        this.prixTete.textContent = '+' + euros(total);
      } else if (this.prixBase() > 0) {
        this.prixTete.textContent = prefixe + '+' + euros(this.prixBase());
      } else {
        this.prixTete.textContent = '';
      }
    }
    if (this.soustitre) {
      if (this.__soustitreInitial === undefined) {
        this.__soustitreInitial = this.soustitre.textContent;
      }
      this.soustitre.textContent = this.actif()
        ? 'Personnalisation active'
        : this.__soustitreInitial;
    }
  };

  Perso.prototype.prixBase = function () {
    for (var i = 0; i < this.config.champs.length; i++) {
      var c = this.config.champs[i];
      if (c.id !== this.champPrincipal) continue;
      if (c.type === 'interrupteur') return c.prix || 0;
      /* Choix declencheur : le « des +X » de l'en-tete est le moins
         cher des choix payants. */
      var minimum = 0;
      (c.choix || []).forEach(function (x) {
        if (x.prix > 0 && (minimum === 0 || x.prix < minimum)) minimum = x.prix;
      });
      return minimum;
    }
    return 0;
  };

  /* ---------------- validation ---------------- */

  Perso.prototype.manquants = function () {
    var self = this;
    var out = [];

    this.champsAValider().forEach(function (champ) {
      var etat = self.etat[champ.id];
      if (etat && etat.valeur) {
        self.noeuds[champ.id].classList.remove('is-missing');
        return;
      }
      out.push(champ.label.replace(' *', ''));
      self.noeuds[champ.id].classList.add('is-missing');
      /* le champ manquant peut etre dans le groupe replie : on l'ouvre */
      var groupe = self.noeuds[champ.id].closest('[data-groupe]');
      if (groupe && !groupe.classList.contains('is-open')) {
        var tete = groupe.querySelector('.mjf-perso__groupe-tete');
        if (tete) tete.click();
      }
    });

    return out;
  };

  Perso.prototype.erreur = function (texte) {
    if (!this.zoneErreur) return;
    this.zoneErreur.textContent = texte || '';
    this.zoneErreur.classList.toggle('is-cache', !texte);
    if (texte) {
      var premier = this.corps.querySelector('.is-missing');
      if (premier && premier.scrollIntoView) {
        premier.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  };

  /* ---------------- proprietes lisibles sur le parent ---------------- */

  Perso.prototype.proprietes = function () {
    var self = this;
    var props = {};
    var actif = this.actif();

    this.config.champs.forEach(function (champ) {
      if (!actif && !champ.hors_accordeon) return;
      if (!self.champVisible(champ)) return;
      var etat = self.etat[champ.id];
      if (!etat || !etat.valeur) return;
      if (!champ.propriete) return;

      var valeur;
      if (champ.type === 'interrupteur') {
        valeur = champ.valeur_propriete || champ.label;
        if (champ.prix > 0) valeur += ' ( +' + euros(champ.prix) + ' )';
      } else if (champ.type === 'pastilles' && etat.choixMultiples) {
        var morceaux = [];
        etat.choixMultiples.forEach(function (c) {
          morceaux.push(c.libelle + (c.prix > 0 ? ' ( +' + euros(c.prix) + ' )' : ''));
        });
        valeur = morceaux.join(', ');
      } else if (champ.type === 'pastilles' && etat.choix) {
        valeur = etat.choix.libelle;
        if (etat.choix.prix > 0) valeur += ' ( +' + euros(etat.choix.prix) + ' )';
      } else {
        valeur = etat.valeur;
        if (champ.type === 'texte' && champ.variante && champ.prix > 0) {
          valeur += ' ( +' + euros(champ.prix) + ' )';
        }
      }

      props[champ.propriete] = valeur;
    });

    return props;
  };

  /* ---------------- ajout au panier ---------------- */

  /* =========================================================
     Ajout au panier : UN SEUL /cart/add.js, quels que soient le
     nombre d'accordeons actifs et de champs hors accordeon presents
     sur la fiche. Une box peut ainsi porter la personnalisation du
     qamis, celle du tapis, le keffieh inclus et le parfum : tout
     entre ensemble ou rien n'entre.
     ========================================================= */

  function ajouterGroupe(participants, varianteProduit, quantite) {
    var manquantsTotaux = [];

    participants.forEach(function (m) {
      m.erreur('');
      var manquants = m.manquants();
      if (manquants.length) {
        m.erreur(m.root.getAttribute('data-texte-champs-manquants') + manquants.join(', ') + '.');
        manquantsTotaux = manquantsTotaux.concat(manquants);
      }
    });
    if (manquantsTotaux.length) return Promise.reject('validation');

    var ligneId = 'ps_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var titreProduit =
      (participants[0] && participants[0].root.getAttribute('data-produit-titre')) || '';

    /* Proprietes de tous les participants, fusionnees sur le parent. */
    var props = {};
    participants.forEach(function (m) {
      var p = m.proprietes();
      Object.keys(p).forEach(function (cle) {
        props[cle] = p[cle];
      });
    });
    props['_box_ligne'] = ligneId;

    var items = [{ id: varianteProduit, quantity: quantite, properties: props }];

    participants.forEach(function (m) {
      m.lignes().forEach(function (l) {
        items.push({
          id: l.variante,
          quantity: quantite,
          properties: {
            '_box_parent': ligneId,
            '_box_parent_nom': titreProduit
          }
        });
      });
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error(data.description || data.message || 'ajout');
        }
        return data;
      });
    });
  }

  /* =========================================================
     Rafraichissement du panier + ouverture du tiroir.
     Reprise du pattern eprouve de mjf-cart-box.js : les noms
     de sections sont lus dans la page, jamais devines.
     ========================================================= */

  function sectionsDuPanier() {
    var trouvees = [];
    var hotes = document.querySelectorAll('cart-drawer-component, cart-items-component');
    for (var i = 0; i < hotes.length; i++) {
      var section = hotes[i].closest('[id^="shopify-section-"]');
      if (!section) continue;
      var nom = section.id.replace('shopify-section-', '');
      var deja = trouvees.some(function (t) { return t.nom === nom; });
      if (!deja) trouvees.push({ nom: nom, id: section.id });
    }
    return trouvees;
  }

  function rafraichirPanier() {
    var sections = sectionsDuPanier();
    if (!sections.length) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      return Promise.resolve(true);
    }
    var noms = sections.map(function (s) { return s.nom; });

    return fetch('/?sections=' + encodeURIComponent(noms.join(',')), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (rendus) {
        var remplace = false;
        sections.forEach(function (s) {
          var html = rendus[s.nom];
          var hote = document.getElementById(s.id);
          if (!html || !hote) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frais = doc.getElementById(s.id) || doc.body.firstElementChild;
          if (!frais) return;
          hote.innerHTML = frais.innerHTML;
          remplace = true;
        });
        if (remplace) {
          ['cart:update', 'cart:refresh'].forEach(function (nom) {
            document.dispatchEvent(new CustomEvent(nom, { bubbles: true, detail: { source: 'mjf-perso' } }));
          });
        }
        return remplace;
      })
      .catch(function () { return false; });
  }

  function ouvrirTiroir() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') { drawer.open(); return; }
    if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return; }
    var dlg = drawer.querySelector('dialog');
    if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return; }
    var bouton = drawer.querySelector('button');
    if (bouton) bouton.click();
  }

  /* =========================================================
     Interception de l'ajout au panier du theme.

     Principe de securite : quand la personnalisation est
     INACTIVE, on ne touche a rien, le theme fait son ajout
     normalement. Quand elle est ACTIVE, on capte le clic
     avant le composant du theme et on envoie notre ajout
     atomique a la place.
     ========================================================= */

  var moteurs = [];
  var envoiEnCours = false;

  function moteurDeLaPage() {
    /* le moteur actif le plus recent encore present dans la page */
    for (var i = moteurs.length - 1; i >= 0; i--) {
      if (document.contains(moteurs[i].root)) return moteurs[i];
    }
    return null;
  }

  function formulaireProduit(node) {
    var form = node.closest ? node.closest('form') : null;
    if (!form) return null;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return null;
    if (!form.querySelector('[name="id"]')) return null;
    return form;
  }

  function intercepter(e) {
    var participants = [];
    for (var i = 0; i < moteurs.length; i++) {
      if (!document.contains(moteurs[i].root)) continue;
      if (moteurs[i].participe()) participants.push(moteurs[i]);
    }
    if (!participants.length) return;

    if (!e.target.closest) return;

    /* Les interactions internes des formulaires de personnalisation
       ne doivent jamais etre interceptees. */
    if (e.target.closest('[data-mjf-perso], [data-mjf-perso-hote]')) return;

    /* Un clic n'est un declencheur d'achat que s'il vise le bouton de
       soumission lui-meme ; « form » seul capterait tous les clics du
       formulaire produit. La soumission du formulaire, elle, reste
       interceptee en propre. */
    var declencheur;
    if (e.type === 'submit') {
      declencheur = e.target;
    } else {
      declencheur = e.target.closest('button[type="submit"], [name="add"]');
    }
    if (!declencheur) return;

    var form = formulaireProduit(declencheur);
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (envoiEnCours) return;
    envoiEnCours = true;

    var champVariante = form.querySelector('[name="id"]');
    var champQuantite = form.querySelector('[name="quantity"]');
    var variante = champVariante ? parseInt(champVariante.value, 10) : 0;
    var quantite = champQuantite ? parseInt(champQuantite.value, 10) || 1 : 1;

    ajouterGroupe(participants, variante, quantite)
      .then(function () {
        return rafraichirPanier();
      })
      .then(function (ok) {
        envoiEnCours = false;
        if (ok) {
          ouvrirTiroir();
        } else {
          window.location.href = '/?panier=ouvert';
        }
      })
      .catch(function (err) {
        envoiEnCours = false;
        if (err !== 'validation') {
          participants[0].erreur(participants[0].root.getAttribute('data-texte-erreur-ajout'));
        }
      });
  }

  /* ---------------- accordeon ---------------- */

  function brancherAccordeon(moteur) {
    /* Conteneur nu : pas d'en-tete a brancher. */
    if (!moteur.tete) return;
    moteur.tete.addEventListener('click', function () {
      var ouvert = moteur.root.classList.toggle('is-open');
      moteur.tete.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      moteur.corps.classList.toggle('is-cache', !ouvert);

      /* premiere ouverture : on active l'interrupteur principal,
         c'est ce que le client est venu chercher */
      if (ouvert && !moteur.actif()) {
        var principal = moteur.noeuds[moteur.champPrincipal];
        var coche = principal ? principal.querySelector('input[type="checkbox"]') : null;
        if (coche && !coche.disabled && !coche.checked) {
          coche.checked = true;
          coche.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  Perso.prototype.brancher = function () {
    brancherAccordeon(this);
  };

  /* ---------------- demarrage ---------------- */

  function init() {
    /* Lecture de la page dans l'ordre du DOM :
       - un bloc maitre actif ouvre un lot et adopte les champs qui
         suivent ;
       - un bloc maitre inactif (frontiere) ferme le lot en cours :
         les champs qui suivent sont ignores jusqu'au prochain maitre ;
       - une Option rejoint le dernier Choix du lot en cours. */
    var noeuds = document.querySelectorAll(
      '[data-mjf-perso], [data-mjf-perso-frontiere], [data-mjf-perso-barriere], script[data-mjf-perso-champ], script[data-mjf-perso-option]'
    );

    var lots = [];
    var courant = null;
    var dernierChoix = null;

    for (var i = 0; i < noeuds.length; i++) {
      var n = noeuds[i];

      if (n.hasAttribute('data-mjf-perso')) {
        courant = { root: n, champs: [] };
        lots.push(courant);
        dernierChoix = null;
        continue;
      }

      if (n.hasAttribute('data-mjf-perso-frontiere')) {
        courant = null;
        dernierChoix = null;
        continue;
      }

      if (n.hasAttribute('data-mjf-perso-barriere')) {
        /* Choix ecarte de ce produit : ses Options ne doivent
           rejoindre aucun autre champ. */
        dernierChoix = null;
        continue;
      }

      var donnees;
      try {
        donnees = JSON.parse(n.textContent);
      } catch (e) {
        continue;
      }

      if (n.hasAttribute('data-mjf-perso-option')) {
        if (courant && dernierChoix) {
          if (!dernierChoix.__optionsAdoptees) {
            dernierChoix.__optionsAdoptees = true;
            dernierChoix.choix = [];
          }
          if (dernierChoix.inclus) donnees.prix = 0;
          dernierChoix.choix.push(donnees);
        }
        continue;
      }

      if (courant && donnees && donnees.id) {
        /* Champ « article inclus » : deja paye avec le produit.
           Prix neutralises des le depart : ni ligne panier, ni tarif
           affiche. Seule la valeur choisie part sur la commande. */
        if (donnees.inclus && donnees.choix) {
          for (var z = 0; z < donnees.choix.length; z++) donnees.choix[z].prix = 0;
        }
        courant.champs.push(donnees);
        dernierChoix = donnees.type === 'pastilles' ? donnees : null;
      }
    }

    for (var l = 0; l < lots.length; l++) {
      var root = lots[l].root;
      if (root.__mjfPersoFait) continue;
      root.__mjfPersoFait = true;
      var m = new Perso(root, lots[l].champs);
      if (m.config) moteurs.push(m);
    }

    masquerEnveloppes();
    elargirEnveloppes();
    appliquerVisibiliteMaitres();
    normaliserPile();
  }

  /* ---------------------------------------------------------------
     Plusieurs accordeons peuvent se suivre sur une meme fiche (perso
     qamis, perso tapis, completez votre box). Leur marge haute est un
     reglage de bloc, donc partagee entre tous les produits : une marge
     negative, utile quand l'accordeon est seul, ferait chevaucher le
     precedent dans une pile.

     Regle : le premier accordeon visible garde sa marge configuree,
     les suivants prennent un ecart de pile fixe. Les fiches a un seul
     accordeon ne sont pas touchees.
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     Un bloc maitre peut n'apparaitre que si un champ de la fiche est
     rempli, y compris un champ pilote par un AUTRE maitre : c'est ce
     qui permet a la personnalisation du tapis de ne surgir qu'une fois
     un tapis ajoute au coffret. Masque, le bloc n'envoie rien.
     --------------------------------------------------------------- */
  function appliquerVisibiliteMaitres() {
    for (var i = 0; i < moteurs.length; i++) {
      var m = moteurs[i];
      if (!m.champConditionnel) continue;

      /* Le champ surveille doit exister sur CE produit. S'il n'y est
         pas (ecarte par sa valeur d'activation, ou propre a une autre
         fiche), la condition ne s'applique pas : le bloc reste visible.
         Sans quoi la personnalisation du tapis, conditionnee au
         carrousel du coffret jilbab, disparaitrait des box qamis ou ce
         carrousel n'existe pas. */
      var existe = false;
      var rempli = false;
      for (var k = 0; k < moteurs.length; k++) {
        var champs = moteurs[k].config.champs;
        for (var c = 0; c < champs.length; c++) {
          if (champs[c].id === m.champConditionnel) existe = true;
        }
        var etat = moteurs[k].etat[m.champConditionnel];
        if (etat && etat.valeur) rempli = true;
      }

      m.root.style.display = !existe || rempli ? '' : 'none';
    }
  }

  function normaliserPile() {
    var ECART_PILE = 8;
    var visibles = [];
    var tous = document.querySelectorAll('[data-mjf-perso]');

    for (var i = 0; i < tous.length; i++) {
      if (tous[i].classList.contains('mjf-perso--nu')) continue;
      visibles.push(tous[i]);
    }

    for (var k = 1; k < visibles.length; k++) {
      var courant = visibles[k];
      var marge = parseFloat(window.getComputedStyle(courant).marginBlockStart);
      if (isNaN(marge) || marge < ECART_PILE) {
        courant.style.marginBlockStart = ECART_PILE + 'px';
      }
    }
  }

  /* ---------------------------------------------------------------
     Certains conteneurs du theme dimensionnent leurs blocs sur le
     contenu : l'accordeon se retrouve alors moins large que la
     colonne. On etire la chaine des enveloppes qui ne contiennent
     que lui, jusqu'au conteneur partage.
     --------------------------------------------------------------- */
  function elargirEnveloppes() {
    var racines = document.querySelectorAll(
      '[data-mjf-perso], [data-mjf-perso-lien], .mjf-perso-hote'
    );
    var hotes = [];
    for (var i = 0; i < racines.length; i++) {
      var enveloppe = racines[i];
      var estHote = enveloppe.classList.contains('mjf-perso-hote');
      while (
        enveloppe.parentElement &&
        enveloppe.parentElement !== document.body &&
        enveloppe.parentElement.children.length === 1 &&
        !enveloppe.parentElement.classList.contains('shopify-section')
      ) {
        enveloppe = enveloppe.parentElement;
        enveloppe.style.width = '100%';
        enveloppe.style.maxWidth = '100%';
        enveloppe.style.boxSizing = 'border-box';
      }
      if (estHote) hotes.push(enveloppe);
    }

    compacterHotes(hotes);
  }

  /* ---------------------------------------------------------------
     Deux champs « hors accordeon » qui se suivent sont deux blocs du
     theme : l'espacement du conteneur s'ajoute a leurs marges, ce qui
     creuse un large blanc entre deux carrousels. On annule cet
     espacement entre hotes consecutifs ; les marges reglees sur les
     blocs suffisent alors a espacer.
     --------------------------------------------------------------- */
  function compacterHotes(hotes) {
    for (var i = 0; i < hotes.length; i++) {
      var enveloppe = hotes[i];
      var precedent = enveloppe.previousElementSibling;
      if (!precedent) continue;
      if (hotes.indexOf(precedent) === -1) continue;

      var parent = enveloppe.parentElement;
      if (!parent) continue;
      var style = window.getComputedStyle(parent);
      var ecart = parseFloat(style.rowGap || style.gap);
      if (isNaN(ecart) || ecart <= 0) continue;

      enveloppe.style.marginBlockStart = '-' + ecart + 'px';
    }
  }

  /* ---------------------------------------------------------------
     Le theme enveloppe chaque bloc dans son propre conteneur et
     espace ces conteneurs entre eux. Nos definitions sont invisibles
     mais leurs enveloppes occupaient chacune un cran d'espacement :
     une quinzaine de blocs champs creusaient un trou avant le bouton
     d'achat. On replie donc, pour chaque definition, la chaine des
     enveloppes qui ne contiennent qu'elle. Jamais en mode editeur,
     ou les etiquettes doivent rester visibles.
     --------------------------------------------------------------- */
  function masquerEnveloppes() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    var noeuds = document.querySelectorAll('.mjf-perso__def, [data-mjf-perso-frontiere]');
    for (var i = 0; i < noeuds.length; i++) {
      var enveloppe = noeuds[i];
      while (
        enveloppe.parentElement &&
        enveloppe.parentElement !== document.body &&
        enveloppe.parentElement.children.length === 1 &&
        !enveloppe.parentElement.hasAttribute('data-mjf-perso') &&
        !enveloppe.parentElement.classList.contains('shopify-section')
      ) {
        enveloppe = enveloppe.parentElement;
      }
      enveloppe.style.display = 'none';
    }
  }

  document.addEventListener('click', intercepter, true);
  document.addEventListener('submit', intercepter, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { init(); });
})();